import { render, staticRenderFns } from "./SalaryExportParameter.vue?vue&type=template&id=05fded9f"
import script from "./SalaryExportParameter.vue?vue&type=script&lang=js"
export * from "./SalaryExportParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports